import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { CompleteProfileFlowControllerPageRoutingModule } from './complete-profile-flow-controller-routing.module';

import { CompleteProfileFlowControllerPage } from './complete-profile-flow-controller.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    CompleteProfileFlowControllerPageRoutingModule
  ],
  declarations: [CompleteProfileFlowControllerPage]
})
export class CompleteProfileFlowControllerPageModule {}
